import React from "react";
// import { IoTimeOutline, IoLocationOutline } from "react-icons/io5";
// import { formatEventDate } from "../../utils/formatEventDate";
const IMAGE_BASEURL = process.env.REACT_APP_IMAGE_BASEURL || "";

// const to12Hour = (time) => {
//   if (!time || time === "00:00" || time === "null" || time === "undefined") {
//     return "TBD";
//   }

//   const [hour, minute] = time.split(":");
//   const dt = new Date();
//   dt.setHours(hour, minute);

//   if (isNaN(dt.getTime())) return "TBD";

//   return dt.toLocaleTimeString([], {
//     hour: "2-digit",
//     minute: "2-digit",
//     hour12: true,
//   });
// };

const PassCard = ({
  // title,
  // startTime,
  // startDate,
  // location,
  memberType,
  passHolder,
  qrCodeUrl,
  ticketId,
  onDownload,
  // onclose,
}) => {
  const qrUrl = `${IMAGE_BASEURL}${qrCodeUrl}`;

  return (
    <div className="pass-card position-relative">
      {/* Header */}
      {/* <button
        type="button"
        className="calendar-close-btn ms-auto position-absolute pass-close-icon"
        onClick={onclose}
        aria-label="Close"
      >
        ✕
      </button>
      <div className="pass-header p-4">
        <div>
          <h1 className="fw-semibold f-26 text-main mb-3">{title}</h1>

          <div className="pass-meta d-flex flex-column">
            <span>
              <IoTimeOutline />
              {`${formatEventDate(startDate)} • ${to12Hour(startTime)}`}
            </span>
            <span>
              <IoLocationOutline /> {location}
            </span>
          </div>
        </div>
      </div> */}

      {/* Body */}
      <div className="pass-body m-sm-4 m-3 px-3 py-3">
        <div className="pass-info">
          <p className="mb-1 value text-main"> {memberType}</p>
          <p className="value text-main mb-0">{passHolder}</p>

          <button className="btn btn-orange-md my-3" onClick={onDownload}>
            Download Ticket
          </button>

          {ticketId && <p className="ticket-id">{ticketId}</p>}

          <p className="qr-note">
            Present this QR code at the event entrance for entry
          </p>
        </div>

        <div className="qr-wrapper">
          <img src={qrUrl} alt="QR Code" />
        </div>
      </div>
    </div>
  );
};

export default PassCard;
